import { configureStore } from '@reduxjs/toolkit'

import { moviesApi } from '../services/moviesData'
import locationReducer from '../features/locationSlice'
import movieReducer from '../features/movieSlice'

export default configureStore({
  reducer: {
    movie: movieReducer,
    location: locationReducer,
    [moviesApi.reducerPath]: moviesApi.reducer,  


  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(moviesApi.middleware),

})

